import { combineReducers } from 'redux'

import arquivosAtaRegistroPreco from './arquivosAtaRegistroPreco'

export default combineReducers({ arquivosAtaRegistroPreco })
